import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileDown, TrendingUp, TrendingDown } from "lucide-react";
import { eur } from "@/lib/workflow";

function Change({ v }) {
  if (v === null || v === undefined) return <span className="text-slate-400">–</span>;
  const up = v >= 0;
  const I = up ? TrendingUp : TrendingDown;
  return <span className={`inline-flex items-center gap-1 font-semibold ${up ? "text-emerald-700" : "text-red-700"}`}><I size={14} />{`${up ? "+" : ""}${v.toLocaleString("de-DE")} %`}</span>;
}

const COLS = ["count", "net", "gross", "paid", "open"];
const cell = (k, v) => (k === "count" ? v : eur(v));

function YearTable({ y }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-x-auto" data-testid={`overview-year-${y.year}`}>
      <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
        <div className="font-display text-lg font-bold text-slate-900">{y.year}</div>
        <div className="text-sm text-slate-500">ggü. Vorjahr: <Change v={y.change_pct} /></div>
      </div>
      <table className="w-full text-sm min-w-[640px]">
        <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-100">
          <th className="px-4 py-2">Ausgabe</th>{["Anzeigen", "Netto", "Brutto", "bezahlt", "offen"].map((h) => <th key={h} className="px-4 py-2 text-right">{h}</th>)}
        </tr></thead>
        <tbody className="divide-y divide-slate-100">
          {y.issues.map((r) => (
            <tr key={r.issue_id} data-testid={`overview-issue-${r.issue_id}`}>
              <td className="px-4 py-2 font-medium text-slate-800">{r.issue_name}</td>
              {COLS.map((k) => <td key={k} className={`px-4 py-2 text-right ${k === "open" && r.open > 0 ? "text-amber-700" : ""}`}>{cell(k, r[k])}</td>)}
            </tr>
          ))}
          <tr className="bg-slate-50 font-semibold" data-testid={`overview-total-${y.year}`}>
            <td className="px-4 py-2">Summe {y.year}</td>
            {COLS.map((k) => <td key={k} className="px-4 py-2 text-right">{cell(k, y.totals[k])}</td>)}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export function YearOverview({ openPdf }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/documents/overview").then((r) => setData(r.data)).catch(() => setData({ years: [] })); }, []);
  return (
    <div className="space-y-4" data-testid="year-overview">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-slate-500">Grundlage sind die gestellten Rechnungen, gruppiert nach Ausgabe und Jahr des Redaktionsschlusses. Die Veränderung bezieht sich auf die Netto-Einnahmen.</p>
        {openPdf && <Button variant="outline" onClick={() => openPdf("/documents/overview.pdf", {}, false)} data-testid="overview-pdf"><FileDown size={16} className="mr-1.5" /> Jahresübersicht als PDF</Button>}
      </div>
      {data && !data.years.length && <div className="bg-white border border-slate-200 rounded-xl p-8 text-center text-slate-400" data-testid="overview-empty">Es wurden noch keine Rechnungen gestellt.</div>}
      {data?.years.map((y) => <YearTable key={y.year} y={y} />)}
    </div>
  );
}
